import { render } from "./ColorInputPanel.vue?vue&type=template&id=143c4e26"
import script from "./ColorInputPanel.vue?vue&type=script&lang=js"
export * from "./ColorInputPanel.vue?vue&type=script&lang=js"

import "./ColorInputPanel.vue?vue&type=style&index=0&id=143c4e26&lang=css"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__